import React, { useEffect } from "react";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import RoundButton from "../../../Common/RoundButton";
import { useDispatch, useSelector } from "react-redux";
import { getKycBacked } from "../PersonalInfo/personalInfoAction";
import ErrorMessage from "../../../Common/ErrorMessage";

const CkycDetails = () => {
  const dispatch = useDispatch();

  const {kycBackedData,kycBackedError} = useSelector(
    (state: any) => state.personalInfo
  );

  useEffect(()=> {
        if(kycBackedData || kycBackedError){
          if(kycBackedData?.status && kycBackedData?.result){
            window.open(kycBackedData?.result?.url);
          }
        }
  },[kycBackedData,kycBackedError])

  const handleFetchKyc = () => {
    dispatch(getKycBacked())
  }

  return (
    <>
      <BackgroundTheme>
        <p
          className="text-otpinfo-styles"
          dangerouslySetInnerHTML={{ __html: "It seems you are not CKYC registered user, Please try investing again in two weeks" }}
        />
        {
          kycBackedError?.error && <ErrorMessage text = {kycBackedError?.error}/>
        }

        <div style={{ marginTop: '50px' }} />
        < div style={{ marginTop: "30px" }} />
        <div className="bottomBtn">
          <RoundButton onClick={handleFetchKyc} title={"proceed OKYC"} />
        </div>
      </BackgroundTheme>
    </>
  );
};

export default CkycDetails;